import React, { useState } from 'react';
import Modal from './Modal';

const SupportModal = ({ isOpen, onClose }) => {
  const [method, setMethod] = useState('btc');
  const [copiedAddress, setCopiedAddress] = useState('');

  const copyToClipboard = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedAddress(label);
      setTimeout(() => setCopiedAddress(''), 1500);
    } catch (err) {
      console.error('Copy failed', err);
      alert('Failed to copy. Please copy manually.');
    }
  };

  const wallets = {
    btc: {
      title: 'Bitcoin (BTC only)',
      address: 'bc1qm2h7nttym3yu4lmcyyhrnzxgv7vkln37zj5fzd',
      qr: '/img/qr/btc-bip21.png',
      label: 'BTC',
    },
    erc20: {
      title: 'USDT (ERC‑20)',
      address: '0x363CcCa0eC32a64D9674baF861CCA5da2E62E8F4',
      qr: '/img/qr/usdt-erc20.png',
      label: 'ERC20',
    },
    trc20: {
      title: 'USDT (TRC‑20)',
      address: 'TXTg48Lh6d9mbFWCgHx1WtxHvvwPdd6NBH',
      qr: '/img/qr/usdt-trc20.png',
      label: 'TRC20',
    },
    ton: {
      title: 'USDT (TON)',
      address: 'UQCb5YvrpIcCBvSoHvJR5bBcTtliHvndTal-yk-x_IljHQEG',
      qr: '/img/qr/usdt-ton.png',
      label: 'TON',
    },
  };

  const currentWallet = wallets[method];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Support the Project">
      <div className="support-content">
        <p>
          Donations help improve the product and keep the service running. Thank you for your
          support!
        </p>

        <div className="method-toggle" aria-label="Payment Method">
          <button
            className={`btn xs ${method === 'btc' ? 'secondary' : 'ghost'} method-btn`}
            onClick={() => setMethod('btc')}
          >
            BTC
          </button>
          <button
            className={`btn xs ${method === 'erc20' ? 'secondary' : 'ghost'} method-btn`}
            onClick={() => setMethod('erc20')}
          >
            USDT ERC‑20
          </button>
          <button
            className={`btn xs ${method === 'trc20' ? 'secondary' : 'ghost'} method-btn`}
            onClick={() => setMethod('trc20')}
          >
            USDT TRC‑20
          </button>
          <button
            className={`btn xs ${method === 'ton' ? 'secondary' : 'ghost'} method-btn`}
            onClick={() => setMethod('ton')}
          >
            USDT TON
          </button>
        </div>

        <div className="method-panel">
          <h3>{currentWallet.title}</h3>
          <div className="wallet-address">
            <p>
              <strong>Address:</strong>
            </p>
            <code className="address-code">{currentWallet.address}</code>
            <button
              className="btn xs secondary copy-btn"
              onClick={() => copyToClipboard(currentWallet.address, currentWallet.label)}
            >
              {copiedAddress === currentWallet.label ? '✓ Copied!' : 'Copy address'}
            </button>
          </div>
          <div className="qr-wrap">
            <img src={currentWallet.qr} alt={`${currentWallet.label} QR`} className="qr" />
          </div>
        </div>

        <div className="support-notice">
          <p className="muted">
            <small>
              <strong>Tips:</strong> Choose the correct network; ERC‑20 needs ETH for gas; TRC‑20
              needs a little TRX.
            </small>
          </p>
          <p>
            <em>Thank you for your support! 🙏</em>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default SupportModal;
